/** Types de liaison (structures, modules, …) — billets / projets / tâches. */
export const ENTITY_LINK_TYPES = [
  { value: 'structures', label: 'Structures' },
  { value: 'modules', label: 'Modules' },
  { value: 'automations', label: 'Automatisations' },
  { value: 'emails', label: 'Courriels' },
  { value: 'dashboards', label: 'Tableaux de bord' },
  { value: 'reports', label: 'Rapports' },
  { value: 'portals', label: 'Portail client' },
  { value: 'integrations', label: 'Intégrations' },
  { value: 'pdf', label: 'PDF' },
  { value: 'location', label: 'Ressources' },
  { value: 'account', label: 'Compte' },
  { value: 'project', label: 'Projet' },
];

export const MAX_ENTITY_LINKS = 50;

export const linkTypeLabel = (type) =>
  ENTITY_LINK_TYPES.find((t) => t.value === type)?.label || type;

export const normalizeEntityLinks = (links, max = MAX_ENTITY_LINKS) => {
  if (!Array.isArray(links)) return [];
  return links
    .filter((l) => l && typeof l === 'object' && l.type)
    .slice(0, max)
    .map((l) => ({
      type: String(l.type),
      mode: l.mode === 'new' ? 'new' : 'existing',
      id: l.id != null ? String(l.id) : null,
      name: l.name ? String(l.name) : '',
    }));
};
